export default [
  {
    path: '/calendar',
    name: 'calendar',
    meta: {
      requiresAuth: true,
      title: 'Calendars - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/CalendarView.vue'),
  },
  {
    path: '/day-at-a-glance',
    name: 'day-at-a-glance',
    meta: {
      requiresAuth: true,
      title: 'Day at a Glance - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/DayAtAGlance.vue'),
  },
]
